import { DI } from '@intigral/constant/config/DIContainer';
import { IRewardService } from '@intigral/domain/lib/application/services/RewardService';
import { container } from '@intigral/domain/lib/DataDomain';
import user from '../../../helpers/user';
import { isGuestUser } from '../../../config/guestMode';
import { isSDKInitialized } from './LiveLikeService';

export const fetchBackendQuests = async () => {
    if (isGuestUser(user.getUserInfo())) {
        return [];
    }
    try {
        const response = await container
            .resolve<IRewardService>(DI.SERVICES.IRewardService)
            .getQuests(user.getIdentityToken(), user.getAPIKey());
        return response?.results || [];
    } catch (e) {
        return [];
    }
};

export const fetchSDKAllQuests = async (sdkClient) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const response = await sdkClient.getQuests();
        return response?.results || [];
    } catch (e) {
        return [];
    }
};
